import React from 'react';
import styles from './DerivedViewsTable.module.scss';
import TableRow from './TableRow';

const DerivedViewsTable = ({ data, agentId }) => {
  return (
    <div className={styles['derived-view-table']}>
      {data?.map((item) => (
        <TableRow key={item?.id} data={item} agentId={agentId} />
      ))}
    </div>
  );
};

export default DerivedViewsTable;
